
const scripts = {ajvValidate: null, powtoonValidate: null}
const getScripts =  async () => {
  if (!scripts.ajvValidate ) {
    const [ajvValidation, {default: schema}, {validate: powtoonValidate}] = await Promise.all([
      import('../../utils/ajvValidation'),
      import('./schema/01.01.schema.json'),
      import('../../utils/powtoonValidation')
    ])
    scripts.ajvValidate = ajvValidation.createValidationForSchema(schema)
    scripts.powtoonValidate = powtoonValidate
    return scripts
  }
  else {return  scripts}
}


export const validate = async powtoon => {
  const validationScripts = await getScripts()

  const powtoonValidationErrors = validationScripts.powtoonValidate(powtoon)
  const ajvValidationErrors = validationScripts.ajvValidate(powtoon)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content){
  if (!content.powtoon.manifest.videos){
    content.powtoon.manifest.videos = {}
  }

  content.powtoon.slides.forEach(slide => {

    // For each slide, change the sourcePanel value from 'images' to 'media'
    slide.tracks.forEach(({sprites}) => {
      const sprite = sprites[0]

      if (sprite.sourcePanel === 'images') {
        sprite.sourcePanel = 'media'
      }

      const content = sprite.content
      const isImageHolder = typeof content === 'object'

      if (isImageHolder) {
        if (content.sourcePanel === 'images') {
          content.sourcePanel = 'media'
        }
      }
    })

    const background = slide.background

    if (typeof background === 'object') {
      if (background.sourcePanel === 'images') {
        background.sourcePanel = 'media'
      }
    }

  })
}
